import React from 'react';
import { Dropdown, Menu } from 'antd';
import { useIntl } from 'react-intl';

import { mediaHook } from 'customHooks';

import { ReactComponent as Help } from 'assets/bosta-icons/help.svg';
import { ReactComponent as Videos } from 'assets/icons/videos.svg';
import { ReactComponent as Webinar } from 'assets/icons/webinar.svg';
import { ReactComponent as Starts } from 'assets/bosta-icons/stars.svg';

import './NeedHelp.less';

const NeedHelp = ({ mobileScreenSizes: { isSmallMobileScreen } }) => {
  const intl = useIntl();

  const HELP_LINKS = {
    en: {
      help_center: 'https://sllr.freshdesk.com/en/support/home',
      short_videos: 'https://www.youtube.com/@SllrEgy/playlists',
      webinars: 'https://sllr.freshdesk.com/en/support/solutions/36000176444',
      products_updates:
        'https://sllr.freshdesk.com/en/support/solutions/36000177351'
    },
    ar: {
      help_center: 'https://sllr.freshdesk.com/ar/support/home',
      short_videos: 'https://www.youtube.com/@SllrEgy/playlists',
      webinars: 'https://sllr.freshdesk.com/ar/support/solutions/36000176444',
      products_updates:
        'https://sllr.freshdesk.com/ar/support/solutions/36000177351'
    }
  };

  const iconsMapper = {
    help_center: <Help />,
    short_videos: <Videos />,
    products_updates: <Starts />,
    webinars: <Webinar />
  };

  const renderMenuLink = (name) => {
    return (
      <Menu.Item>
        <div className="br-need-help__option-dropdown__item">
          {iconsMapper[name]}
          <a href={HELP_LINKS[intl.locale][name]} target="_blank">
            {intl.formatMessage({
              id: `new_header.help.${name}`
            })}
          </a>
        </div>
      </Menu.Item>
    );
  };
  return (
    <Dropdown
      overlay={
        <Menu>
          {renderMenuLink('help_center')}
          {renderMenuLink('short_videos')}
          {renderMenuLink('products_updates')}
          {renderMenuLink('webinars')}
        </Menu>
      }
      overlayClassName="br-need-help__option-dropdown"
    >
      <div className="br-header__right-section__help">
        <Help />

        {!isSmallMobileScreen &&
          intl.formatMessage({
            id: `new_header.help.title`
          })}
      </div>
    </Dropdown>
  );
};

export default mediaHook(NeedHelp);
